<template>
  <div class="container mt-5">
    <!-- Show loading indicator until groups are loaded -->
    <div v-if="loading" class="text-center mb-4">
      <span>Loading...</span>
    </div>

    <!-- Button to start adding a new child -->
    <div v-if="!isEditing" class="text-center mb-4">
      <button class="btn btn-primary" @click="startEditing">
        Új táncos felvétele
      </button>
    </div>
    <!-- Display form if editing and groups are loaded -->
    <div v-if="isEditing && !loading && grps.length > 0">
      <form @submit.prevent="submitForm">
        <div class="mb-3">
          <label for="vezeteknev" class="form-label">Vezetéknév</label>
          <input
            type="text"
            id="vezeteknev"
            v-model="form.vezeteknev"
            class="form-control"
            required
          />
        </div>
        <div class="mb-3">
          <label for="keresztnev" class="form-label">Keresztnév</label>
          <input
            type="text"
            id="keresztnev"
            v-model="form.keresztnev"
            class="form-control"
            required
          />
        </div>
        <div class="mb-3">
          <label for="lakhely" class="form-label">Lakhely</label>
          <input
            type="text"
            id="lakhely"
            v-model="form.lakhely"
            class="form-control"
            required
          />
        </div>
        <div class="mb-3">
          <label for="dancerEmail" class="form-label">Táncos saját email címe (opcionális)</label>
          <input
            type="email"
            id="dancerEmail"
            v-model="form.dancer_email"
            class="form-control"
            placeholder="Ha az új táncosnak saját email címe van"
          />
        </div>
        <div class="mb-3">
          <label for="csoport" class="form-label">Kívánt csoport</label>
          <select
            id="csoport"
            v-model="form.csoport"
            class="form-select"
            required
          >
            <option v-for="group in grps" :key="group.id" :value="group.id">
              {{ group.name }}
            </option>
          </select>
        </div>
        <div class="text-center">
          <button type="submit" class="btn btn-primary">
            Mentés
          </button>
          <button type="button" class="btn btn-secondary" @click="cancelForm">
            Mégse
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
        // Define the prop that will receive the value from the parent
        parent_1_mail: {
          type: String,
          required: true
        },
        parent_2_mail: {
          type: String,
          required: true
        }
      },
  data() {
    return {
      isEditing: false, // Track whether the form is in editing mode
      loading: false, // Track whether the groups are still loading
      form: {
        vezeteknev: '',
        keresztnev: '',
        lakhely: '',
        dancer_email: '',
        csoport: null
      },
      grps: [], // Array to hold group data
      
    };
  },
  methods: {
    // Start editing and fetch group data when button is clicked
    startEditing() {
      this.loading = true; // Start loading groups
      axios.get(`${this.$BACKEND_HOST}/api/settings/groups/info`)
        .then(response => {
          this.grps = response.data.groups; // Set group data after fetching
          this.loading = false; // Set loading to false after the groups are loaded
          this.isEditing = true; // Enable form editing after data is fetched
        })
        .catch(err => {
          console.error('Error fetching groups:', err.message);
          this.loading = false; // Ensure loading state is updated
        });
    },
    
    // Handle the form submission (POST request with Axios)
    submitForm() {
      const postData = {
        child_familyname: this.form.vezeteknev,
        child_surename: this.form.keresztnev,
        child_addr: this.form.lakhely,
        child_desired_grp: this.form.csoport,
        dancer_email: this.form.dancer_email,
        p1_mail: this.parent_1_mail,
        p2_mail: this.parent_2_mail
      };

      console.log(postData);

      // Send data via POST request
      axios.post(`${this.$BACKEND_HOST}/api/addnewchild`, postData)
        .then(response => {
          console.log('Form successfully submitted:', response.data);
          this.isEditing = false; // Exit editing mode after submission
          this.resetForm(); // Reset the form
        })
        .catch(err => {
          console.error('Error submitting form:', err.message);
        });
    },

    // Handle cancel (reset the form and close the editor)
    cancelForm() {
      this.isEditing = false; // Exit editing mode without saving
      this.resetForm(); // Reset form data
    },

    // Reset form fields
    resetForm() {
      this.form = {
        vezeteknev: '',
        keresztnev: '',
        lakhely: '',
        dancer_email: '',
        csoport: null
      };
    }
  }
};
</script>

<style scoped>
/* Additional styles for the inline form can be added here */
</style>
